import { createContext } from 'react';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';

type MyCardsLayoutContextValue = {
  defaultRarity: Rarity;
};

export const MyCardsLayoutContext = createContext<MyCardsLayoutContextValue>({
  defaultRarity: Rarity.limited,
});
